"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YoutubeWrap = exports.YoutubePlay = void 0;

var _styles = require("@material-ui/core/styles"); // Youtube play button for video content preview
// Can be generic but is used only for youtube video thumbnails


var YoutubePlay = (0, _styles.styled)('div')({
  width: '70px',
  height: '46px',
  zIndex: 1,
  borderRadius: '14%',
  transition: 'all 0.2s cubic-bezier(0, 0, 0.2, 1)',
  backgroundColor: 'red',
  opacity: 1,
  position: 'relative',
  transform: 'scale(var(--youtube-button-size, 0.8))',
  '&:before': {
    content: '""',
    borderColor: 'transparent transparent transparent #fff',
    borderStyle: 'solid',
    borderWidth: '11px 0 11px 19px',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate3d(-50%, -50%, 0)'
  }
});
exports.YoutubePlay = YoutubePlay;
var YoutubeWrap = (0, _styles.styled)('div')({
  display: 'inline-block',
  position: 'relative',
  '&.ended': {
    '&::after': {
      content: ' ',
      position: 'absolute',
      top: '0',
      left: '0',
      bottom: '0',
      right: '0',
      cursor: 'pointer',
      backgroundColor: 'black',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '64px 64px',
      backgroundImage: 'url(data:image/svg+xml;utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2aWV3Qm94PSIwIDAgNTEwIDUxMCI+PHBhdGggZD0iTTI1NSAxMDJWMEwxMjcuNSAxMjcuNSAyNTUgMjU1VjE1M2M4NC4xNSAwIDE1MyA2OC44NSAxNTMgMTUzcy02OC44NSAxNTMtMTUzIDE1My0xNTMtNjguODUtMTUzLTE1M0g1MWMwIDExMi4yIDkxLjggMjA0IDIwNCAyMDRzMjA0LTkxLjggMjA0LTIwNC05MS44LTIwNC0yMDQtMjA0eiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg==)'
    }
  },
  '&.paused': {
    '&::after': {
      content: ' ',
      position: 'absolute',
      top: '70px',
      left: '0',
      bottom: '50px',
      right: '0',
      cursor: 'pointer',
      backgroundColor: 'black',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '40px 40px',
      backgroundImage: 'url(data:image/svg+xml;utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEiIHdpZHRoPSIxNzA2LjY2NyIgaGVpZ2h0PSIxNzA2LjY2NyIgdmlld0JveD0iMCAwIDEyODAgMTI4MCI+PHBhdGggZD0iTTE1Ny42MzUgMi45ODRMMTI2MC45NzkgNjQwIDE1Ny42MzUgMTI3Ny4wMTZ6IiBmaWxsPSIjZmZmIi8+PC9zdmc+)'
    }
  }
});
exports.YoutubeWrap = YoutubeWrap;